import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout, ProductKey } from './MetaPixel';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} className={className} data-id="element-436">
    {children}
  </motion.div>;
interface ButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  className?: string;
  /**
   * When set, fires Meta Pixel `InitiateCheckout` with the
   * matching value + currency right before the link navigates.
   */
  trackingProduct?: ProductKey;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export const CTAButton = ({
  href,
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  trackingProduct,
  onClick
}: ButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (trackingProduct) {
      try {
        trackInitiateCheckout(trackingProduct);
      } catch {
        // never block navigation on tracking failure
      }
    }
    if (onClick) onClick(e);
  };
  return <a href={href} onClick={handleClick} className={`
        inline-flex items-center justify-center gap-2 transition-all duration-300
        ${fullWidth ? 'w-full' : ''}
        ${variant === 'primary' ? 'gold-metallic-bg text-black font-sans font-extrabold uppercase tracking-wide text-base px-9 py-4 rounded-[14px] shadow-[0_0_30px_rgba(240,188,76,0.45),0_4px_16px_rgba(240,188,76,0.35)] hover:-translate-y-0.5 hover:shadow-[0_0_50px_rgba(240,188,76,0.65)] animate-glow-button' : 'bg-bg-card text-txt-primary font-bold border border-line hover:bg-bg-highlight hover:border-gray-600 text-[15px] px-8 py-4 rounded-[14px]'}
        ${className}
      `} data-id="element-437">
      {children}
    </a>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-10 md:py-20 px-4 md:px-6 overflow-hidden ${className}`} data-id="element-438">
    <div className="max-w-[1100px] mx-auto" data-id="element-439">{children}</div>
  </section>;